import { Button, Stack } from "@mui/material";

import { AddRoutePointETAModal } from "components/AddRoutePointETAModal";

import { useDisclosure } from "../../hooks";

interface Props {
  shipment: CondensedShipment;
  onETACreatedSuccess: VoidFunction | null;
}

export function AddRoutePointETAButton(props: Props) {
  const { shipment, onETACreatedSuccess } = props;
  const {
    isOpen: addRoutePointETAModalOpen,
    onClose: onCloseRoutePointETA,
    onOpen: onOpeRoutePointETA,
  } = useDisclosure(false);

  if (
    !shipment ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT" ||
    shipment.shipment_status === "DELIVERED" ||
    shipment.shipment_status === "BOOKING_CANCELLED" ||
    shipment.shipment_status === "CANCELLED"
  ) {
    return null;
  }

  return (
    <Stack>
      <Button color="info" onClick={onOpeRoutePointETA} variant="contained">
        Add ETA
      </Button>
      <AddRoutePointETAModal
        shipment={shipment}
        modalOpen={addRoutePointETAModalOpen}
        onModalClose={onCloseRoutePointETA}
        onETACreatedSuccess={onETACreatedSuccess}
      />
    </Stack>
  );
}
